// Copyright (c) 2019 Comsearch, Inc., All rights reserved

// bandAnalysisStatuses is an array of interference analysis type statuses for this project && band.
// it will be 0 <= X <= analysisTypes.length
// If no analysis has been run for the given projectId && bandId && analysisTypeId,
// then we'll need to use default values since they're not provided.

// NOTE - we pass the bandId and projectId in manually because when there is no typeStatus,
// we still need to be able to tell which bandId and projectId are associated with this
// status object that we're making up on the spot to fill in the UI.
// these are used to handle the click event on the analysis status row which will
// take the user to that selected/specific AFS Grid.
const makeBandStatuses = (bandAnalysisStatuses, bandId, projectId) => (dispatch, getState) => {
  const analysisTypes = getState().interferenceAnalysis.get('analysisTypes')

  return analysisTypes.reduce((a, d, i) => {
    const analysisTypeId = d.get('analysisTypeId')
    const analysisType = d.get('analysisType')

    // find the associated status for this analysis type
    const typeStatus = bandAnalysisStatuses.find(s => s.analysisTypeId === analysisTypeId)

    // uses default values if there is no matching typeStatus
    const statusSummary = {
      analysisStatus: 'No Status',
      analysisStatusId: null,
      analysisType,
      analysisTypeId,
      bandId,
      endTime: null,
      projectId,
      startTime: null,
      submitTime: null,
      ...typeStatus,
    }

    a.push(statusSummary)

    return a
  }, [])
}

export default makeBandStatuses
